import React, {Component} from "react";
import {connect} from "react-redux";
import {Group} from "react-konva";
import PipeStickComponent from "./pipe-stick-component";
import { PIPE_ELEMENT_TYPE_STICK, PIPE_BED_PIPE_ROWS, PIPE_FLOW_ARROW_ORIENTATION } from "../../../lib/types";
import {
    doesPipeFlowDirectionStartOnTop,
} from "../../../actions/pipe-bed-actions";

class PipeRowComponent extends Component {
  renderSticksWithFlow() {
    const {
      doesPipeFlowDirectionStartOnTop,
    } = this.props;
    if (doesPipeFlowDirectionStartOnTop()) {
      return this.renderSticksWithTopToBottomFLow()
    } else {
      return this.renderSticksWithBottomToTopFLow()
    }
  }

  renderSticksWithBottomToTopFLow() {
    let yPos = 0;
    let key = 0;

    let firstCutStickCount = 0;
    let secondCutStickCount = 0;
    if (this.props.numberOfCutLengthPipeSticksPerRow === 2) {
      firstCutStickCount = 1;
      secondCutStickCount = 1;
    } else {
      secondCutStickCount = this.props.numberOfCutLengthPipeSticksPerRow;
    }

    const firstCutSticks = [...new Array(firstCutStickCount)].map((x, i) => {
      let id = {
        section: PIPE_BED_PIPE_ROWS,
        row: this.props.index,
        index: key,
        type: PIPE_ELEMENT_TYPE_STICK
      };
      yPos = this.props.rowPipeStickCutLength * i;
      return <PipeStickComponent arrowOrientation={PIPE_FLOW_ARROW_ORIENTATION.UP} id={id} key={key++}
                                 length={this.props.rowPipeStickCutLength} y={yPos}/>
    });

    yPos = 0;

    const maxLengthSticks = [...new Array(this.props.numberOfMaxLengthPipeSticksPerRow)].map((x, i) => {
      let id = {
        section: PIPE_BED_PIPE_ROWS,
        row: this.props.index,
        index: key,
        type: PIPE_ELEMENT_TYPE_STICK
      };
      const yOffset = firstCutStickCount * this.props.rowPipeStickCutLength;
      yPos = this.props.rowPipeStickMaxLength * i;
      return <PipeStickComponent arrowOrientation={PIPE_FLOW_ARROW_ORIENTATION.UP} id={id} key={key++}
                                 length={this.props.rowPipeStickMaxLength} y={yPos + yOffset}/>
    });

    yPos = 0;

    const secondCutSticks = [...new Array(secondCutStickCount)].map((x, i) => {
      let id = {
        section: PIPE_BED_PIPE_ROWS,
        row: this.props.index,
        index: key,
        type: PIPE_ELEMENT_TYPE_STICK
      };
      const yOffset = (this.props.numberOfMaxLengthPipeSticksPerRow * this.props.rowPipeStickMaxLength)
      + (firstCutStickCount * this.props.rowPipeStickCutLength);
      yPos = this.props.rowPipeStickCutLength * i;
      return <PipeStickComponent arrowOrientation={PIPE_FLOW_ARROW_ORIENTATION.UP} id={id} key={key++}
                                 length={this.props.rowPipeStickCutLength} y={yPos + yOffset}/>
    });

    return [...firstCutSticks, maxLengthSticks, secondCutSticks]
  };

  renderSticksWithTopToBottomFLow() {
    let yPos = 0;
    let key = 0;

    let firstCutStickCount = 0;
    let secondCutStickCount = 0;
    if (this.props.numberOfCutLengthPipeSticksPerRow === 2) {
      firstCutStickCount = 1;
      secondCutStickCount = 1;
    } else {
      firstCutStickCount = this.props.numberOfCutLengthPipeSticksPerRow;
    }

    const firstCutSticks = [...new Array(firstCutStickCount)].map((x, i) => {
      let id = {
        section: PIPE_BED_PIPE_ROWS,
        row: this.props.index,
        index: key,
        type: PIPE_ELEMENT_TYPE_STICK
      };
      yPos = this.props.rowPipeStickCutLength * i;
      return <PipeStickComponent arrowOrientation={PIPE_FLOW_ARROW_ORIENTATION.DOWN} id={id} key={key++}
                                 length={this.props.rowPipeStickCutLength} y={yPos}/>
    });

    yPos = 0;

    const maxLengthSticks = [...new Array(this.props.numberOfMaxLengthPipeSticksPerRow)].map((x, i) => {
      let id = {
        section: PIPE_BED_PIPE_ROWS,
        row: this.props.index,
        index: key,
        type: PIPE_ELEMENT_TYPE_STICK
      };
      yPos = this.props.rowPipeStickMaxLength * i;
      const yOffset = firstCutStickCount * this.props.rowPipeStickCutLength;
      return <PipeStickComponent arrowOrientation={PIPE_FLOW_ARROW_ORIENTATION.DOWN} id={id} key={key++}
                                 length={this.props.rowPipeStickMaxLength} y={yPos + yOffset}/>
    });

    yPos = 0;

    const secondCutSticks = [...new Array(secondCutStickCount)].map((x, i) => {
      let id = {
        section: PIPE_BED_PIPE_ROWS,
        row: this.props.index,
        index: key,
        type: PIPE_ELEMENT_TYPE_STICK
      };
      yPos = this.props.rowPipeStickCutLength * i;
      const yOffset = (firstCutStickCount * this.props.rowPipeStickCutLength) + (this.props.numberOfMaxLengthPipeSticksPerRow * this.props.rowPipeStickMaxLength);
      return <PipeStickComponent arrowOrientation={PIPE_FLOW_ARROW_ORIENTATION.DOWN} id={id} key={key++}
                                 length={this.props.rowPipeStickCutLength} y={yPos + yOffset}/>
    });

    return [...firstCutSticks, maxLengthSticks, secondCutSticks]
  };

  render() {
    return (
      <Group
        x={this.props.x}
        y={this.props.y}
      >
        {this.renderSticksWithFlow()}
      </Group>
    );
  }
}

const mapStateToProps = state => {
  return {
    nominalDiameter: state.pipeGlobals.pipeNominalDiameter,
    numberOfMaxLengthPipeSticksPerRow: state.pipeBed.numberOfMaxLengthPipeSticksPerRow,
    numberOfCutLengthPipeSticksPerRow: state.pipeBed.numberOfCutLengthPipeSticksPerRow,
    rowPipeStickCutLength: state.pipeBed.rowPipeStickCutLength.px,
    rowPipeStickMaxLength: state.pipeGlobals.pipeNominalDiameter.lengthMax.px,
    pipeFlowDirection: state.pipeGlobals.pipeFlowDirection
  };
};

export default connect(
  mapStateToProps,
  {
    doesPipeFlowDirectionStartOnTop,
  }
)(PipeRowComponent);



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/pipe-row-component.js